import { render, staticRenderFns } from "./CRMDetails.vue?vue&type=template&id=7f09028a&scoped=true"
import script from "./CRMDetails.vue?vue&type=script&lang=js"
export * from "./CRMDetails.vue?vue&type=script&lang=js"
import style0 from "./CRMDetails.vue?vue&type=style&index=0&id=7f09028a&prod&lang=less"
import style1 from "./CRMDetails.vue?vue&type=style&index=1&id=7f09028a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f09028a",
  null
  
)

export default component.exports